import S from 'common/service/sanctuary';
import { compose } from 'ramda';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { bool, func, string } from 'prop-types';
import Main from 'common/mdc/layout';
import Search, { Advanced, Summary } from '@sma/components/device/search';
import Primary from '@sma/components/device/primary';
import Secondary from '@sma/components/device/secondary';
import { actions as tagActions } from "@sma/store/tag/tags";
import AttachTagDialog from '../components/device/attachDialog/attachTagDialog';

import {
  selectors,
  actions,
} from '@sma/store/device/devices';

import {
  selectors as searchSelectors,
} from '@sma/store/device/search';

export const messages = defineMessages({
  title: {
    id: 'title.devices',
    defaultMessage: 'Meters',
  },
  search: {
    id: 'search.devices.placeholder',
    defaultMessage: 'Search for meters',
  },
});

const showTagFilter = (openAttachDialog)=>{
  openAttachDialog(true);
}

const Devices = ({
  intl,
  selectedDevice,
  clearSelection,
  searchExpanded,
  showAttachTagDialog,
  openAttachDialog,
  removeDevicesFilterByTag,
  showAttachTagDialogToFilter,
  clearSelectedTagsList,
}) => (
  <Main
    title={<FormattedMessage {...messages.title} />}
    tools={
      <Fragment>
        <Search />
        <Summary />
      </Fragment>
    }
    toolbar={searchExpanded ? <Advanced showTagFilter={openAttachDialog} removeDevicesFilterByTag={removeDevicesFilterByTag} clearSelectedTagsList={clearSelectedTagsList}/> : null}
  >
    <Primary />
    {S.maybeToNullable(S.map(device => (
      <Secondary device={device} onClose={clearSelection} />
    ), selectedDevice))}
    { showAttachTagDialog ? <AttachTagDialog devicesFilter={showAttachTagDialogToFilter} deviceId={S.maybeToNullable(S.map(device => (device.deviceId), selectedDevice))} /> : null }
  </Main>
);

Devices.propTypes = {
  clearSelection: func.isRequired,
  searchExpanded: bool.isRequired,
  query: string,
  intl: intlShape.isRequired,
  loading: bool,
};

Devices.defaultProps = {
  query: '',
  loading: false,
};

export default compose(
  connect(
    state => ({
      selectedDevice: selectors.getSelected(state),
      searchExpanded: searchSelectors.isExpanded(state),
      showAttachTagDialog: state.tags.attachTag.showDialog,
      showAttachTagDialogToFilter: state.tags.attachTag.fromDeviceFilter,
    }),
    ({
      clearSelection: actions.clearSelected,
      openAttachDialog: tagActions.showAttchTagDialog,
      removeDevicesFilterByTag: actions.removeDevicesFilterByTag,
      clearSelectedTagsList: tagActions.clearSelectedTagsList,
    }),
  ),
  injectIntl,
)(Devices);
